import { LeafSpinner } from "./spinner.component.js";
customElements.define("leaf-spinner", LeafSpinner);
export {
  LeafSpinner
};
//# sourceMappingURL=spinner.js.map
